import classNames from 'classnames';
import { FormattedDate } from 'react-intl';
import styled from 'styled-components';

import { Skeleton } from '@sorare/core/src/atoms/animations/Skeleton';
import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineS, LabelS } from '@sorare/core/src/atoms/typography';
import { DateOrFixturePicker } from '@sorare/core/src/components/lobby/DateOrFixturePicker';
import { WithSlug } from '@sorare/core/src/components/lobby/DateOrFixturePicker/types';

const DateWrapper = styled(ButtonBase)`
  border: 1px solid var(--c-nd-100);
  border-radius: var(--double-unit);
  padding: var(--unit) var(--intermediate-unit);

  &.selected {
    color: var(--c-black);
    background-color: var(--c-white);
  }
`;

const SkeletonStyled = styled(Skeleton)`
  width: 50px;
  height: 55px;
  border-radius: var(--double-unit);
`;

type Props<T extends WithSlug> = {
  dates: T[];
  value: T;
  onChange: (date: T) => void;
};

export const DatePicker = <T extends WithSlug>({
  dates,
  value,
  onChange,
}: Props<T>) => {
  return (
    <DateOrFixturePicker
      withMask
      items={dates}
      value={value}
      renderPlaceholder={() => <SkeletonStyled />}
      renderItem={({ item: date }) => (
        <DateWrapper
          onClick={() => onChange(date)}
          className={classNames({
            selected: date.slug === value.slug,
          })}
        >
          <Vertical gap={0} center>
            <LabelS>
              <FormattedDate value={date.slug} weekday="short" />
            </LabelS>
            <HeadlineS>
              <FormattedDate value={date.slug} day="numeric" />
            </HeadlineS>
          </Vertical>
        </DateWrapper>
      )}
    />
  );
};
